// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isSunday as fn } from "../isSunday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isSunday = convertToFP(fn, 1);

// Fallback for modularized imports:
export default isSunday;
